import React from "react";
import Template from "../components/Template";

function RefundPolicy() {
  return (
    <Template>
      <div className="section-lgx pb-0"></div>
      <section className="section-lgx">
        <div className="container">
          <h1>Refund Policy</h1>
          <p className="updated-date">Last updated: 7 January 2026</p>

          <p>
            Thank you for choosing <strong>Coach Elite</strong>. Please read
            this Refund Policy carefully before making a payment.
          </p>

          <h5>No Refund Policy</h5>
          <p>
            Once a payment is successfully completed for any of our services,
            programs, subscriptions, coaching sessions, or digital products, we
            do not offer refunds under any circumstances.
          </p>

          <p>By making a payment, you acknowledge and agree that:</p>

          <ul>
            <li>All payments are final and non-refundable</li>
            <li>We do not provide refunds for:</li>
          </ul>

          <ul>
            <li>Change of mind</li>
            <li>Partial usage of services</li>
            <li>Missed sessions or non-participation</li>
            <li>Dissatisfaction after purchase</li>
            <li>Subscription cancellations after payment</li>
            <li>Any personal or technical issues on the user’s side</li>
          </ul>

          <h5>Why No Refunds?</h5>
          <p>Our services involve:</p>

          <ul>
            <li>
              Immediate access to premium content, coaching materials, or
              resources
            </li>
            <li>Allocation of time, expertise, and digital infrastructure</li>
            <li>
              Reserved slots, planning, and preparation specific to each client
            </li>
          </ul>

          <p>
            Due to the nature of these services, refunds are not feasible once
            access or service delivery begins.
          </p>

          <h5>Payment Confirmation = Agreement</h5>
          <p>By completing the payment, you confirm that:</p>

          <ul>
            <li>You have reviewed all service details before purchasing</li>
            <li>You understand and accept this No Refund Policy</li>
            <li>
              You agree that no refund, chargeback, or reversal will be
              requested
            </li>
          </ul>

          <h5>Exceptions</h5>
          <p>
            Refunds will only be considered if required by applicable law.
            Otherwise, no exceptions will be made.
          </p>

          <h5>Contact Us</h5>
          <p>
            If you have any questions before making a payment, please contact
            us:
          </p>
          <p>
            📧{" "}
            <a href="mailto:coaching@dailyfitzone.com">coaching@dailyfitzone.com</a>
          </p>

          <p>
            We strongly encourage users to clarify all doubts prior to
            purchasing.
          </p>
        </div>
      </section>
    </Template>
  );
}

export default RefundPolicy;
